import type { Resource } from '../../';
export const product_sizeChart_measurements_mx: Resource = {"default":"Mexico"};
